import RequestAbstract from "../abstract";

export default class MarketingAudiences extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/audience-lists";
    }

    // Переопределяем метод для использования GET запроса
    async getAllFiltered(
        filter = [],
        sort = [{ field: 'id', direction: 'DESC' }],
        props = {}
    ) {
        // Всегда используем GET запрос для получения кампаний
        let url = this.link;
        
        // Добавляем параметры в URL если они есть
        const params = new URLSearchParams();
        
        if (props.paging) {
            if (props.paging.page !== undefined) {
                params.append('page', props.paging.page);
            }
            if (props.paging.pageSize !== undefined) {
                params.append('pageSize', props.paging.pageSize);
            }
        }
        
        if (sort && sort.length > 0) {
            params.append('sortField', sort[0].field);
            params.append('sortDirection', sort[0].direction);
        }
        
        if (filter && filter.length > 0) {
            params.append('filter', JSON.stringify(filter));
        }
        
        if (params.toString()) {
            url += '?' + params.toString();
        }
        
        return await this.get(url);
    }

    // Переопределяем метод search для использования GET запроса
    async search(limit, filter = [], sort = [], props) {
        let url = this.link;
        
        // Добавляем параметры в URL если они есть
        const params = new URLSearchParams();
        
        if (limit) {
            params.append('pageSize', limit);
        }
        
        if (sort && sort.length > 0) {
            params.append('sortField', sort[0].field);
            params.append('sortDirection', sort[0].direction);
        }
        
        if (filter && filter.length > 0) {
            params.append('filter', JSON.stringify(filter));
        }
        
        if (params.toString()) {
            url += '?' + params.toString();
        }
        
        return await this.get(url);
    }
}
